const countryTranslations = {
  ad: "Andorre",
  ae: "Émirats arabes unis",
  af: "Afghanistan",
  ag: "Antigua-et-Barbuda",
  ai: "Anguilla",
  al: "Albanie",
  am: "Arménie",
  ao: "Angola",
  ar: "Argentine",
  as: "Samoa américaines",
  at: "Autriche",
  au: "Australie",
  aw: "Aruba",
  ax: "Îles Åland",
  az: "Azerbaïdjan",
  ba: "Bosnie-Herzégovine",
  bb: "Barbade",
  bd: "Bangladesh",
  be: "Belgique",
  bf: "Burkina Faso",
  bg: "Bulgarie",
  bh: "Bahreïn",
  bi: "Burundi",
  bj: "Bénin",
  bl: "Saint-Barthélemy",
  bm: "Bermudes",
  bn: "Brunéi Darussalam",
  bo: "Bolivie",
  bq: "Pays-Bas caribéens",
  br: "Brésil",
  bs: "Bahamas",
  bt: "Bhoutan",
  bw: "Botswana",
  by: "Biélorussie",
  bz: "Belize",
  ca: "Canada",
  cc: "Îles Cocos",
  cd: "Congo-Kinshasa",
  cf: "République centrafricaine",
  cg: "Congo-Brazzaville",
  ch: "Suisse",
  ci: "Côte d’Ivoire",
  ck: "Îles Cook",
  cl: "Chili",
  cm: "Cameroun",
  cn: "Chine",
  co: "Colombie",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cap-Vert",
  cw: "Curaçao",
  cx: "Île Christmas",
  cy: "Chypre",
  cz: "Tchéquie",
  de: "Allemagne",
  dj: "Djibouti",
  dk: "Danemark",
  dm: "Dominique",
  do: "République dominicaine",
  dz: "Algérie",
  ec: "Équateur",
  ee: "Estonie",
  eg: "Égypte",
  eh: "Sahara occidental",
  er: "Érythrée",
  es: "Espagne",
  et: "Éthiopie",
  fi: "Finlande",
  fj: "Fidji",
  fk: "Îles Malouines",
  fm: "États fédérés de Micronésie",
  fo: "Îles Féroé",
  fr: "France",
  ga: "Gabon",
  gb: "Royaume-Uni",
  gd: "Grenade",
  ge: "Géorgie",
  gf: "Guyane française",
  gg: "Guernesey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenland",
  gm: "Gambie",
  gn: "Guinée",
  gp: "Guadeloupe",
  gq: "Guinée équatoriale",
  gr: "Grèce",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinée-Bissau",
  gy: "Guyana",
  hk: "R.A.S. chinoise de Hong Kong",
  hn: "Honduras",
  hr: "Croatie",
  ht: "Haïti",
  hu: "Hongrie",
  id: "Indonésie",
  ie: "Irlande",
  il: "Israël",
  im: "Île de Man",
  in: "Inde",
  io: "Territoire britannique de l’océan Indien",
  iq: "Irak",
  ir: "Iran",
  is: "Islande",
  it: "Italie",
  je: "Jersey",
  jm: "Jamaïque",
  jo: "Jordanie",
  jp: "Japon",
  ke: "Kenya",
  kg: "Kirghizistan",
  kh: "Cambodge",
  ki: "Kiribati",
  km: "Comores",
  kn: "Saint-Christophe-et-Niévès",
  kp: "Corée du Nord",
  kr: "Corée du Sud",
  kw: "Koweït",
  ky: "Îles Caïmans",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Liban",
  lc: "Sainte-Lucie",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Libéria",
  ls: "Lesotho",
  lt: "Lituanie",
  lu: "Luxembourg",
  lv: "Lettonie",
  ly: "Libye",
  ma: "Maroc",
  mc: "Monaco",
  md: "Moldavie",
  me: "Monténégro",
  mf: "Saint-Martin",
  mg: "Madagascar",
  mh: "Îles Marshall",
  mk: "Macédoine du Nord",
  ml: "Mali",
  mm: "Myanmar (Birmanie)",
  mn: "Mongolie",
  mo: "R.A.S. chinoise de Macao",
  mp: "Îles Mariannes du Nord",
  mq: "Martinique",
  mr: "Mauritanie",
  ms: "Montserrat",
  mt: "Malte",
  mu: "Maurice",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexique",
  my: "Malaisie",
  mz: "Mozambique",
  na: "Namibie",
  nc: "Nouvelle-Calédonie",
  ne: "Niger",
  nf: "Île Norfolk",
  ng: "Nigéria",
  ni: "Nicaragua",
  nl: "Pays-Bas",
  no: "Norvège",
  np: "Népal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nouvelle-Zélande",
  om: "Oman",
  pa: "Panama",
  pe: "Pérou",
  pf: "Polynésie française",
  pg: "Papouasie-Nouvelle-Guinée",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Pologne",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Porto Rico",
  ps: "Territoires palestiniens",
  pt: "Portugal",
  pw: "Palaos",
  py: "Paraguay",
  qa: "Qatar",
  re: "La Réunion",
  ro: "Roumanie",
  rs: "Serbie",
  ru: "Russie",
  rw: "Rwanda",
  sa: "Arabie saoudite",
  sb: "Îles Salomon",
  sc: "Seychelles",
  sd: "Soudan",
  se: "Suède",
  sg: "Singapour",
  sh: "Sainte-Hélène",
  si: "Slovénie",
  sj: "Svalbard et Jan Mayen",
  sk: "Slovaquie",
  sl: "Sierra Leone",
  sm: "Saint-Marin",
  sn: "Sénégal",
  so: "Somalie",
  sr: "Suriname",
  ss: "Soudan du Sud",
  st: "Sao Tomé-et-Principe",
  sv: "Salvador",
  sx: "Saint-Martin (partie néerlandaise)",
  sy: "Syrie",
  sz: "Eswatini",
  tc: "Îles Turques-et-Caïques",
  td: "Tchad",
  tg: "Togo",
  th: "Thaïlande",
  tj: "Tadjikistan",
  tk: "Tokelau",
  tl: "Timor oriental",
  tm: "Turkménistan",
  tn: "Tunisie",
  to: "Tonga",
  tr: "Turquie",
  tt: "Trinité-et-Tobago",
  tv: "Tuvalu",
  tw: "Taïwan",
  tz: "Tanzanie",
  ua: "Ukraine",
  ug: "Ouganda",
  us: "États-Unis",
  uy: "Uruguay",
  uz: "Ouzbékistan",
  va: "État de la Cité du Vatican",
  vc: "Saint-Vincent-et-les-Grenadines",
  ve: "Venezuela",
  vg: "Îles Vierges britanniques",
  vi: "Îles Vierges des États-Unis",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis-et-Futuna",
  ws: "Samoa",
  ye: "Yémen",
  yt: "Mayotte",
  za: "Afrique du Sud",
  zm: "Zambie",
  zw: "Zimbabwe"
};
export default countryTranslations;
